// removed by extract-text-webpack-plugin
module.exports = {"table":"styles__table___2-j79","tableHeader":"styles__tableHeader___3Sog0","tableCellClass":"styles__tableCellClass___BKKSr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Table/styles.css
// module id = 365
// module chunks = 0